import API from "./api";
import { ADMIN_CREATE, ADMIN_LIST } from "./endpoint";

export const adminCreate = (data) => {
  return API.post(ADMIN_CREATE, data);
};

export const getAdminsList = () => {
  return API.get(ADMIN_LIST);
};


export const updateAdmin = (id, data) => {
  return API.post(`/admin/update/${id}`, data);
};

export const deleteAdmin = (id) => {
  return API.delete(`/admin/delete/${id}`);
};
export const getMyAdminProfile = () => {
  return API.get("/admin/me");
};

